export default __webpack_public_path__ + "static/media/digital-itap-logo.83e77420.svg";